<template>
<VueFinalModal
    v-bind="$attrs"
    classes="flex justify-center items-center"
    :content-class="[
        bodyClass,
        'modal-base',
        {'px-4 md:py-4': !noPadding}
    ]"
    :click-to-close="clickToClose"
    @opened="opened"
    @before-close="beforeClose">
    <slot />
</VueFinalModal>
</template>

<script setup>
import { onBeforeUnmount } from 'vue';
import { useErrorStore } from '@/stores/error';

defineOptions({
    inheritAttrs: true
});

const props = defineProps({
    bodyClass: {
        type: String,
        default: 'modal-large-content'
    },

    headerClass: {
        type: String,
        default: ''
    },

    // Keep errors on inputs when modal is closed
    keepErrors: {
        type: Boolean,
        default: false
    },

    // Gives modal a set height
    fixedHeight: {
        type: Boolean,
        default: true
    },

    noPadding: {
        type: Boolean,
        default: true
    },
    clickToClose: {
        type: Boolean,
        default: false
    }
});

onBeforeUnmount(() => {
    clearErrors();
    unlockScroll();
});

const reset = useErrorStore().reset;

let scrollLockCount = 0;
let savedScrollY = 0;

function clearErrors() {
    if (!props.keepErrors) {
        reset();
    }
};

function lockScroll() {
    if (scrollLockCount === 0) {
        savedScrollY = window.scrollY;
        document.documentElement.style.top = `-${savedScrollY}px`;
        document.documentElement.classList.add('fixed');
    }
    scrollLockCount++;
}

function unlockScroll() {
    if (scrollLockCount <= 0) {
        return;
    }
    scrollLockCount--;
    if (scrollLockCount === 0) {
        document.documentElement.classList.remove('fixed');
        document.documentElement.style.top = '';
        window.scrollTo(0, savedScrollY);
    }
}

function opened() {
    lockScroll();
}

function beforeClose() {
    unlockScroll();
}
</script>
